module.exports = __webpack_public_path__ + "assets/img/goods1.abfe888a.png";